import { FC } from "react";
import { useRecoilValue } from "recoil";

import {
  drawersAtom,
  resolveOffsetWidthMultipleDrawers,
  RIGHTBAR_DEFAULT_WIDTH,
  type IInjectedDrawerProps,
} from "@ryde/shared";

import { DrawerBackdrop } from "./backdrop";
import { DrawerWrapper } from "./wrapper";

interface IBaseDrawerProps extends IInjectedDrawerProps {
  skipCssEnter?: boolean;
  enterDurationSeconds?: number;
}

export const BaseDrawer: FC<IBaseDrawerProps> = ({
  onCloseDrawer,
  customWidth = RIGHTBAR_DEFAULT_WIDTH,
  drawerNumber = 0,
  children,
  skipCssEnter = false,
  enterDurationSeconds,
}) => {
  const drawers = useRecoilValue(drawersAtom);
  // When customWidth is a string, apply offset for multiple stacked drawers;
  // when it's a MotionValue (e.g. ride drawer resize), the hook already includes the offset, so pass through as-is.
  const drawerWidth: NonNullable<IInjectedDrawerProps["customWidth"]> =
    typeof customWidth === "string"
      ? resolveOffsetWidthMultipleDrawers({
          customWidth,
          drawersNumber: drawers.length - 1 - drawerNumber,
        }) + "px"
      : customWidth;

  return (
    <DrawerBackdrop onCloseDrawer={onCloseDrawer} drawerWidth={drawerWidth}>
      <DrawerWrapper
        skipCssEnter={skipCssEnter}
        drawerWidth={drawerWidth}
        enterDurationSeconds={enterDurationSeconds}
      >
        {children}
      </DrawerWrapper>
    </DrawerBackdrop>
  );
};
